<template>
    <div>
        <van-field
                v-model="phone"
                label="手机号码"
                placeholder="请输入手机号码"
                @click-right-icon="$toast('您注册的手机号码')"
                @focus="handleFocus"
                readonly
                :required="required"
        >
        </van-field>
        <van-number-keyboard
                theme="custom"
                :show="numberKeyboardShow"
                close-button-text="完成"
                @blur="numberKeyboardShow = false"
                @input="onInput"
                @delete="onDelete"
        />
    </div>
</template>

<script>
  /**
   * Description: 手机号码自定义键盘组件
   * Author: Wangyan
   * Date: 2019-03-03
   * Time: 18:12
   */
  import { Field, Toast, NumberKeyboard } from 'vant';

  export default {
    name: "PhoneInputNumberKeyBoard",
    components: {
      [Field.name]: Field,
      [Toast.name]: Toast,
      [NumberKeyboard.name]: NumberKeyboard,
    },
    props: {
      question: Boolean, // 是否显示"?"矢量图片
      passPhone: {
        type: String,
        default: ''
      },
      required: Boolean
    },
    data() {
      return {
        phone: '',// 登录手机号码
        numberKeyboardShow: false, // 控制数字键盘的显示与隐藏
        icon: '', // 存放"?"矢量图片
      }
    },
    created() {
      this.phone = this.passPhone
    },
    mounted() {
      if (this.question) {
        this.icon = 'question-o'
      }
    },
    watch: {
      numberKeyboardShow(val) {
        if (!val) {
          this.onClose()
        }
      },
      passPhone(val) {
        this.phone = val
      }
    },
    methods: {

      handleFocus() {
        this.numberKeyboardShow = true
        document.activeElement.blur()
        document.body.scrollTop = document.documentElement.scrollTop = 86
      },
      /**
       * 点击数字键盘后累加输入在手机号码输入框内
       * @param value 每一次点击的数字
       */
      onInput(value) {
        if (this.phone.length < 11) {
          this.phone += value
        }
      },

      /**
       * 删除手机号码输入框内的最后一个字符串
       */
      onDelete() {
        this.phone = this.phone.slice(0, this.phone.length - 1)
      },

      /**
       * 数字键盘消失传值给父组件
       */
      onClose() {
        this.$emit('setPhone', this.phone)
      }
    }
  }
</script>

<style scoped>
    .van-cell:not(:last-child)::after {
        border-bottom: 0;
    }
</style>
